export type PopupDataDto = {
    messageId: number;
    popupName: string;
    name: string;
    popupParameters: PopupParametersDto;
}

export type PopupParametersDto = {
    orderHrefIds: string[]
}

export enum LabelPrintTaskStatus {
    Created = "Created",
    Generating = "Generating",
    Ready = "Ready",
    Failed = "Failed",
    Expired = "Expired"
}

export type LabelPrintTaskDto = {
    id: string;
    avitoAccountName: string;
    status: LabelPrintTaskStatus;
    ordersCount: number;
    createdOn: string;
    orders: string[];
    error?: string;
}

export type SkippedOrderDto = {
    orderHrefId: string;
    reason: string;
}

export type LabelPrintTasksDto = {
    tasks: LabelPrintTaskDto[];
    skipped: SkippedOrderDto[];
}

export type LabelPrintTasksHistoryDto = {
    active: LabelPrintTaskDto[];
    history: LabelPrintTaskDto[];
}
